import React, { Component } from "react";
import Header from "../../layout/Header";
import BannerSimple from "../../layout/BannerSimple";
import Footer from "../../layout/Footer";
import ListOption from "../../layout/ListOption";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import Ascencia from "./Ascencia";

let title = 'Projet Personnel';

class PP extends Component {
	defineTitle(_title){
		document.title = `${_title ? _title : title} - ${window.APP_NAME}`;
		window.resetScript()
	}

	componentDidMount() {
		let { session } = this.props.match.params;
		if (session) {
			this.defineTitle(`${title} ${session}`);
		}
	}

	render() {
		let { session } = this.props.match.params;
		let display;

		if (session) {
			this.defineTitle(`${title} ${session}`);
		}

		switch (session) {
			case "ascencia":
				display = (
					<>
						<BannerSimple title={`${title} ${session}`} boxElement={ [ { name: "Accueil", link: "/" }, { name: title, link: '/ppe' }, { name: `${title} ${session}`, link: window.location.pathname } ] } />

						<Ascencia title={`${title} ${session}`} />
					</>
				);
				break;
			default:
				display = (
					<>
						{ this.defineTitle() }

						<BannerSimple title={title} boxElement = { [ { name: "Accueil", link: "/" }, { name: title, link: window.location.pathname } ] } />

						<ListOption title={title} description="Cette section présente les travaux personnels développé au cours des années" list={
							[
								{
									title: `Projet Ascencia`,
									description: `Creation d'un bot discord en JavaScript (NodeJS)`,
									link: '/pp/ascencia',
									lnr_icon: 'lnr-book'
								},
							]
						} />
					</>
				);
		}

		return (
			<>
				<Header active={ "Projet Personnel" } modeDark={ true } />

				{ display }

				<Footer />
			</>
		);

	}
}

PP.propsTypes = {};

const mapStateToProps = state => ({});

export default connect(
	mapStateToProps,
	{  }
)(withRouter(PP))